









import { Component, Mixins } from "vue-property-decorator";
import { UserSelectableContentMixin } from "./mixins";
import { FatalIndicator } from "./common";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentLoginUserSelector extends Mixins(UserSelectableContentMixin) {
  get isSelectable(): boolean {
    return this.isAccessorEnable;
  }

  async onClicked(): Promise<void> {
    this.users = [ this.$store.getters.user ];
  }
}
